import { render } from "./Onboarding.vue?vue&type=template&id=e7dccdec&scoped=true&ts=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=e7dccdec&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7dccdec"]])

export default __exports__